import { authorize, postRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';
import { mapDataForBackend } from './mapData';

export async function sendOrderAPI(order) {
  const url = `${AWS_API_URL}/user/order`;
  return postRequest(url, mapDataForBackend(order), await authorize());
}
